(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('quickSidebarToggle', [QuickSidebarToggleFn]);

    /* main quick sidebar toggler directive */
    function QuickSidebarToggleFn() {
        var directive = {
            restrict: 'A',
            link: link
        };
        return directive;

        // linker
        function link(scope, element) {
            // body element    
            var body = document.body;   

            // quick sidebar toggler (METRONIC)
            element.on("click", function (e) {
                body.classList.toggle('page-quick-sidebar-open');

                var input = document.querySelector('#searchAgendasInput');
                if (input) {
                    input.focus();
                }

                // hide/show scroll-bar
                if (body.classList.contains("page-quick-sidebar-open")) { body.style.overflowY = 'hidden'; }
                else { body.style.overflowY = 'auto'; }  
            });

            // destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });

        } // link

    }

})();